import * as React from 'react';
import * as _ from 'lodash';
import { NetworkContextElems } from 'golgi';
import { KiwifruitContextElems } from 'kiwifruit-react';
export const NetworkKiwifruitUser = (props) => React.createElement(NetworkContextElems.Consumer, null, (networkContext) => React.createElement(KiwifruitContextElems.Consumer, null, (kiwifruitContext) => {
    if (!networkContext) {
        throw new Error("Cannot use NetworkKiwifruitUser outside of a NetworkProvider");
    }
    if (!kiwifruitContext) {
        throw new Error("Cannot use NetworkKiwifruitUser outside of a KiwifruitSolver");
    }
    return React.createElement(NetworkKiwifruitUserHelper, { networkContext: networkContext, kiwifruitContext: kiwifruitContext, userProps: props });
}));
class NetworkKiwifruitUserHelper extends React.Component {
    constructor(props) {
        super(props);
        this.cellShouldUpdate = false;
        // KIWIFRUIT STUFF
        // TODO: This assumes kiwifruitContext never changes!
        this.solver = props.kiwifruitContext.solver;
        this.id = "interface" + this.solver.newId();
        this.variablesRead = {};
    }
    shouldComponentUpdate(nextProps) {
        this.cellShouldUpdate = this.shouldCellUpdate(nextProps);
        return true;
    }
    shouldCellUpdate(nextProps) {
        // State is delicate – we assume any setState might break our cell
        if (nextProps.userProps.state !== this.props.userProps.state) {
            return true;
        }
        // Hopefully we have a propsChanged function, and can use that to compare props...
        if (this.props.networkContext.propsChanged) {
            if (this.props.networkContext.propsChanged(nextProps.userProps.props, this.props.userProps.props)) {
                return true;
            }
        }
        else if (nextProps.userProps.props !== this.props.userProps.props) {
            return true;
        }
        if (this.variableValueChanged()) {
            // console.log("variableValueChanged!")
            return true;
        }
        return false;
    }
    render() {
        // console.log("rendering NetworkKiwifruitUser (outside) from", (this.props.userProps as any).owner && (this.props.userProps as any).owner.__proto__.constructor.name, (this.props.userProps as any).owner && (this.props.userProps as any).owner.props)
        const { userProps: { render, debugName }, networkContext: { network } } = this.props;
        if (!this.outputCell || this.cellShouldUpdate) {
            this.cellShouldUpdate = false;
            const newOutputCell = network.output(() => {
                this.variablesRead = {};
                const constraints = [];
                const result = render({
                    addConstraint: (...newConstraints) => {
                        constraints.push(...newConstraints);
                    },
                    getVariable: (variableName) => {
                        let value = this.solver.getVariableValue(variableName) || 0;
                        this.variablesRead[variableName] = value;
                        return value;
                    },
                    id: this.id
                });
                // KIWIFRUIT STUFF
                // console.log("setting constraints", constraints.map(Constraint.toString))
                this.solver.setConstraints(this.id, constraints);
                return result;
            }, debugName);
            const result = newOutputCell.get();
            if (this.outputCell) {
                this.outputCell.delete();
            }
            this.outputCell = newOutputCell;
            return result;
        }
        else {
            return this.outputCell.get();
        }
    }
    variableValueChanged() {
        return _.some(this.variablesRead, (readValue, variableName) => {
            const curValue = this.solver.getVariableValue(variableName);
            const changed = (curValue !== undefined && curValue !== readValue);
            // if (changed) {
            //   console.log("value tracked by KiwifruitUser changed!", variableName, readValue, "=>", curValue)
            // }
            return changed;
        });
    }
    componentWillUnmount() {
        if (this.outputCell) {
            this.outputCell.delete();
        } // NETWORK
        this.solver.setConstraints(this.id, []); // KIWIFRUIT
    }
}
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../golgi-kiwifruit/build/index.js
// module id = 89
// module chunks = 0